import { createAction, props } from '@ngrx/store';

import { Application, NewRole, AccessRule, ApplicationGroup } from '../shared/models';

export const init = createAction(
  '[App] Init',
  props<{ externalId: string; system: string; externalEntityTypeEnum: string }>(),
);

export const initialized = createAction('[App] Initalized');

export const setExternalUser = createAction(
  '[App] Set external user',
  props<{ externalId: string; system: string; externalEntityTypeEnum: string }>(),
);

export const setProfileId = createAction('[App] Set profile id', props<{ profileId: number }>());

export const selectApplicationGroups = createAction('[App Component] Select application groups');

export const setApplications = createAction(
  '[App Component] Set applications',
  props<{ applications: Application[] }>(),
);

export const setApplicationGroups = createAction(
  '[App Component] Set application groups',
  props<{ applicationGroups: ApplicationGroup[] }>(),
);

export const setRoles = createAction('[App Component] Set roles', props<{ roles: NewRole[] }>());

export const setAccessRules = createAction(
  '[App Component] Set access rules',
  props<{ accessRules: AccessRule[] }>(),
);

export const deleteGroupUseraccess = createAction(
  '[App Component] Delete group user access for application',
  props<{ groupId: number }>(),
);

export const deleteGroupUseraccessSuccess = createAction(
  '[App Component] Delete group user access for application success',
  props<{ groupId: number }>(),
);

export const setUseraccess = createAction(
  '[App Component] Set user access for application',
  props<{ applicationKey: string; roleKey: string }>(),
);

export const setGroupUseraccess = createAction(
  '[App Component] Set user access for application group',
  props<{ groupId: number }>(),
);
